import React from 'react';
import TpaModal from '../Modal/TpaModal';
import { Button, HoverStyles, Text, TextTypography as TYPOGRAPHY } from 'wix-ui-tpa/cssVars';
import { classes, st } from './UserMessage.st.css';
import { useExperiments } from '@wix/yoshi-flow-editor';

interface UserMessageProps {
  isOpen: boolean;
  onRequestClose: () => void;
  isMobile: boolean;
  isRTL: boolean;
  message: string;
  okLabel: string;
}

const UserMessage: React.FC<UserMessageProps> = ({
  isOpen,
  isMobile,
  isRTL,
  message,
  okLabel,
  onRequestClose,
}) => {
  const { experiments } = useExperiments();
  const isButtonHoverContrastEnabled = experiments.enabled(
    'specs.bookings.buttonHoverContrast',
  );
  return (
    <TpaModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      isMobile={isMobile}
      isRTL={isRTL}
    >
      <div className={st(classes.root)}>
        <Text
          className={st(classes.messageText)}
          typography={TYPOGRAPHY.runningText}
        >
          {message}
        </Text>
        <Button
          className={st(classes.messageButton)}
          onClick={() => onRequestClose()}
          data-hook="user-message-action-button"
          fullWidth={isMobile}
          hoverStyle={
            isButtonHoverContrastEnabled ? HoverStyles.underline : undefined
          }
        >
          {okLabel}
        </Button>
      </div>
    </TpaModal>
  );
};

export default UserMessage;
